import { gql } from "@apollo/client";

export const CREATE_CONTACT_MESSAGE = gql`
    mutation CreateContactMessage($subject: String!, $message: String!) {
        createContactMessage(subject: $subject, message: $message)
    }
`; 